export default __webpack_public_path__ + "static/media/images/rpcb1.9a2427e1.png";